// extracted by mini-css-extract-plugin
export var integrationButton = "_b8-0";